<template>
  <h1 class="hr-main fs-4 fw-normal mb-3">{{ t('stockStatusRequests.title') }}</h1>
  <STable
    @list-query="onListQuery"
    :initial="lm"
    :pagination="true"
    :page-size-options="[5, 10, 20, 50]"
    :persist-key="persistKey"
  />
</template>

<script setup>
import { ref, reactive, computed, watch, provide } from 'vue'
import { commons } from '@/lib/transformer'
import { useApi } from '@/composables/api'
import STable from '@/views/stock/list_status_change.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const { persistKey = '' } = defineProps({
  persistKey: { type: String, default: '' },
})
const lm = ref({ onPage: 5, page: 1 })

const query = reactive({
  order_field: 'id',
  order_direction: 'DESC',
  filter: '',
  filter_id: '',
  search: '',
  onPage: 5,
  page: 1,
})

const apiQuery = computed(() => {
  const base = {
    filter: query.filter,
    filter_id: query.filter_id,
    onPage: query.onPage,
    page: query.page,
    ...(query.search ? { search: query.search } : {}),
  }

  if (query.filter === '' && query.filter_id === '') {
    return {
      ...base,
      order_field: query.order_field,
      order_direction: query.order_direction,
    }
  }

  return base
})

const { model, refresh } = useApi({
  url: 'get_change_status',
  data: { data: [], total_count: null },
  query: apiQuery,
  pick: d => {
    const data = (d?.data || []).map(item => {
      if (item.date_created) item.fmt_date_created = commons.dateLocal(item.date_created, 'Pp')
      return item
    })
    return { data, total_count: d?.total_count ?? data.length }
  },
})

provide('model', model)
provide('refresh', refresh)

function onListQuery(val) {
  if (val && typeof val === 'object') {
    lm.value = { ...val }
  }
}

watch(
  lm,
  val => {
    if (val && typeof val === 'object') {
      Object.assign(query, val)
      refresh()
    }
  },
  { immediate: true, deep: true }
)
</script>
<i18n>
{ "ru": { "stockStatusRequests": { "title": "Запросы на смену статуса позиции" } }, "en": { "stockStatusRequests": { "title": "Item status change requests" } } }
</i18n>
